import * as queries from 'lib/graphql/queries';
import { GraphQLClient } from 'types';
import { poll } from 'lib/poll';
import { RefundType } from 'lib/graphql';

const acceptCancellationQuote = async (client: GraphQLClient, bookingId: string, cancellationId: string, refundType: RefundType) => {
  await queries.acceptCancellation(client, { variables: { bookingId, cancellationId, input: { refundType } } });

  const acceptedResult = await poll({
    requestFn: () => queries.getCancellation(client, { variables: { bookingId, cancellationId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.cancellation.state !== 'ACCEPTING',
  });

  if (!['ACCEPTED', 'FAILED', 'BLOCKED'].includes(acceptedResult.data.cancellation.state)) {
    throw Error(`Unexpected cancellation state "${acceptedResult.data.cancellation.state}"`);
  }

  return acceptedResult.data.cancellation;
};

export default acceptCancellationQuote;
